<template>
  <v-layout wrap justify-center>
    <v-flex px-2 xs12 sm12 md12 lg12 xl12 text-center>
      <vue-element-loading :active="appLoading" :is-full-screen="true" />
      <v-layout wrap>
        <v-flex v-for="(value, key) in cardData" :key="key" xs3 md3 pt-2 pr-2>
          <v-card class="mb-2" style="border-radius: 21px">
            <v-layout wrap justify-center style="height: 150px">
              <v-flex align-self-center>
                <vue-element-loading
                  :active="recentLoading"
                  :is-full-screen="false"
                />
                <v-card-text class="p-3 clearfix">
                  <v-list-item link to="/Users">
                    <template v-for="subitem in imagelist">
                      <v-list-item-avatar
                        :key="subitem.value"
                        v-if="subitem.value == key"
                        style="border-radius: 0pximportant"
                        height="100px"
                        width="100px"
                      >
                        <v-img :src="getImageURL(subitem.image)"></v-img>
                      </v-list-item-avatar>
                    </template>

                    <v-list-item-content>
                      <v-list-item-title
                        style="font-weight: bold;font-size:18px"
                        class="text-capitalize"
                        >{{ key }}</v-list-item-title
                      >
                      <v-list-item-subtitle class="info--text"
                        ><b>Count : {{ value }}</b></v-list-item-subtitle
                      >
                      <v-list-item-subtitle class="info--text"
                        ><br
                      /></v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>


<script>
import axios from "axios";
// import ApexCharts from 'apexcharts'
export default {
  name: "BasicDashboard",
  data: () => ({
    analytics: [],
    appLoading: false,
    recentLoading: false,
    cardData: [],
    imagelist: [
      {
        value: "birds",
        image: "birds.png",
      },
      {
        value: "amphibians",
        image: "amphibians.png",
      },

      {
        value: "mammals",
        image: "mammals.png",
      },
      {
        value: "reptiles",
        image: "reptiles.png",
      },
      {
        value: "total",
        image: "total.jpg",
      },
      {
        value: "others",
        image: "others.png",
      },
    ],
  }),
  mounted() {
    this.dashboardData();
  },
  methods: {
    // years() {
    //   const year = new Date().getFullYear();

    //   return Array.from({ length: year - 2000 },(value, index) => 2001 + index);
    // },
    getImageURL(src) {
      var images = require.context("../../assets/images/");
      return images("./" + src);
    },
    dashboardData() {
      this.recentLoading = true;
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/dashboard/admin",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.recentLoading = false;
          this.appLoading = false;
          if (response.data.status) {
            this.analytics = response.data.data;
            this.cardData = response.data.data.carddata;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>